<template>
  <!-- add face template Modal -->
  <div id="add_user_id_face_template" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Employee Face</h5>
          <button type="button" class="btn-close" ref="Close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
         
                <div class="col-md-12 mb-3">
                  <v-autocomplete v-model="selectedUser" :items="usersData" variant="outlined" density="comfortable"
                    item-title="text" item-value="id" clearable label="Employee Name"></v-autocomplete>
                </div>
              
            <div class="submit-section">
              <button class="btn btn-primary submit-btn" @click="onSubmit" :disabled="loader">
                <span v-if="!loader">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /add face template Modal -->

  
</template>

<script>

import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../config";

export default {
  

  data() {
    return {
      loader: false,
      usersData: [],
      template_image_path:"",
      id:"",
      image_path:"",
      selectedUser:""
    };
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    updateValues(item){
      this.image_path = item.image_path;
      this.selectedUser = item.user_id || "";
      this.loader = false;
    },

     getUsers() {

      axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.usersData = response.data.data;

            this.usersData.forEach(element => {
              element["text"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
        
        });
    },

    async onSubmit() {
      if (!this.selectedUser) {
        this.$toast.error("Please select a user");
        return;
      }


      this.loader = true;
      const formData = new FormData();
      
    
      formData.append("image_path", this.image_path);
      formData.append("user_id", this.selectedUser);

      await axios.post(`${VUE_APP_API_BASE_URL}/face-template/add-user-id`, formData)
        .then((response) => {
          if (response.data.status === true) {
            this.$toast.success(response.data.message);
            this.$refs.Close.click();
            this.$emit('faceAdded');
            this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        }).catch((error) => {
          console.log(error);
          this.loader = false;
          const errMsg = error.response?.data?.message || error.response?.data?.errors || "An error occurred while adding user to face template.";
          this.$toast.error(errMsg);
        });
    },

  },

}
</script>

<style scoped>
.pass-input.is-invalid+.toggle-password {
  bottom: 0;
}

.toggle-password {
  top: 49px !important;
  right: 28px;
  position: absolute;
}
</style>